import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_01Knapsack_BB = () => (
  <DAAModuleSubtopic
    title="Branch and Bound - 0/1 Knapsack"
    videos={[
      "https://www.youtube.com/embed/yV1d-b_NeK8",
      "https://www.youtube.com/embed/VzGAYk1KOJE",
      "https://www.youtube.com/embed/JW-26PaDpds",
      "https://www.youtube.com/embed/G5HxET1pOrY",
    ]}
    takeaways={[
      { text: "Backtracking improves over brute force by ignoring infeasible solutions." },
      { text: "Branch and Bound further optimizes by using bounds to prune the search space." },
      { text: "Bound computation estimates the best possible solution for a node’s subtree." },
      { text: "If the bound is worse than the current best, the node is ignored." },
      { text: "Time Complexity: O(2^n)." },
    ]}
    questions={[
      {
        text: "Consider n = 4, V = {10, 10, 12, 18}, w = {2, 4, 6, 9}, and W = 15. What is the highest profit using the Branch and Bound strategy?",
      },
      {
        text: "Solve the Knapsack Problem using FIFO-BB for knapsack capacity W = 8. Show how a queue is used for node creation in the state space tree.",
        image: "/01knapsackBBq2.png",
      },
      {
        text: "What is the difference between FIFO-BB and LIFO-BB?",
      },
      {
        text: "Solve the Knapsack Problem using LIFO-BB for knapsack capacity W = 8. Show how a stack is used for node creation in the state space tree using variable tuple representation.",
        image: "/01knapsackBBq3.png",
      },
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/CwM-Mv0Bm4Y",
      "https://www.youtube.com/embed/DazyKdW1nLU",
      "https://www.youtube.com/embed/OImTqyxgQCg",
      "https://www.youtube.com/embed/GnmyDOIY_Ls",
      "https://www.youtube.com/embed/wXAZU3l0wDc",
      "https://www.youtube.com/embed/r6jjn_xVu70",
      "https://www.youtube.com/embed/XMY8WkdbVCI",
      "https://www.youtube.com/embed/HXF8EcT6WZk",
    ]}
  />
);

export default DAA_01Knapsack_BB ;
